"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
// text field
var styleOverrides = {
    root: function(param) {
        var theme = param.theme;
        return _define_property({
            borderRadius: theme.shape.borderRadius
        }, "&.".concat(_material.outlinedInputClasses.multiline, " .").concat(_material.inputAdornmentClasses.root), {
            alignSelf: 'flex-start',
            marginTop: 16,
            marginRight: 4,
            marginLeft: 4
        });
    },
    inputSizeSmall: {
        padding: '8.5px 14px'
    },
    adornedStart: _define_property({}, "& .".concat(_material.outlinedInputClasses.input), {
        paddingLeft: 0
    }),
    adornedEnd: _define_property({}, "& .".concat(_material.outlinedInputClasses.input), {
        paddingRight: 0
    }),
    notchedOutline: function(param) {
        var theme = param.theme;
        return {
            background: 'unset',
            borderColor: theme.palette.grey[500],
            '& legend': {
                position: 'unset'
            }
        };
    },
    multiline: {
        padding: 15
    }
};
var defaultProps = {
    color: 'inputElements'
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiOutlinedInput.js.map
